<template>
  <div>
    <v-dialog v-model="show" width="500px">
      <v-card>
        <v-card-title class="d-flex" style="position: relative"
                      :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
          <h3>{{isNew ? 'New Route Cost' : 'Edit Route Cost ' + cost.id}}</h3>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-title class="justify-center">
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-0 pb-0">
          <v-container container--fluid grid-list-xl pt-0 pb-0>
            <v-form
              ref="form"
              v-model="valid">
              <v-row justify="center" align="center">
                <v-col cols="12">
                  <v-select
                    :items="cost_types"
                    item-value="code"
                    item-text="display"
                    v-model="cost.cost_type"
                    label="Cost Type"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row justify="center" align="center">
                <v-col cols="12">
                  <v-select
                    :items="unit_types"
                    item-value="code"
                    item-text="display"
                    v-model="cost.unit_type"
                    label="Unit Type"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row justify="center" align="center">
                <v-col cols="12">
                  <v-select
                    :items="renderedServices"
                    item-value="id"
                    item-text="name"
                    v-model="cost.service_id"
                    label="Service"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row justify="center" align="center">
                <v-col cols="12">
                  <v-select
                    :items="shift_types"
                    item-value="code"
                    item-text="display"
                    v-model="cost.shift"
                    label="Shift"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row justify="center" align="center">
                <v-col cols="12">
                  <v-select
                    :items="renderedZones"
                    item-value="id"
                    item-text="name"
                    v-model="cost.zone_id"
                    label="Zone"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row justify="center" align="center">
                <v-col cols="12">
                  <v-text-field
                    v-model="cost.unit_rate"
                    label="Unit Rate"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row justify="center" align="center">
                <v-col cols="12">
                  <v-text-field
                    v-model="cost.unit_rate_after"
                    label="Unit Rate After"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row justify="center" align="center">
                <v-col cols="12">
                  <v-text-field
                    v-model="cost.unit_rate_before"
                    label="Unit Rate Before"
                    required
                    numeric
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row justify="center" align="center">
                <v-col cols="12">
                  <v-text-field
                    v-model="cost.rate_per_units"
                    label="Rate Per Units"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row justify="center" align="center">
                <v-col cols="12">
                  <v-text-field
                    v-model="cost.fuel_levy"
                    label="Fuel Levy"
                    :rules="[v => (v >= 0)|| 'must be positive number']"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row justify="center" align="center">
                <v-col cols="12" class="pb-0">
                  <v-switch
                    class="justify-center"
                    v-model="cost.rate_per_units_part_thereof"
                    label="Part Thereof"
                  ></v-switch>
                </v-col>
              </v-row>

              <v-row justify="center" align="center">
                <v-col cols="6" style="text-align: center">
                  <v-btn
                    text
                    @click="$emit('close')"
                    color="blue-grey lighten-2"
                  >Cancel
                  </v-btn>
                </v-col>

                <v-col cols="6" style="text-align: center">
                  <v-btn
                    text
                    @click="$emit('save')"
                    color="blue darken-1"
                  >Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "EditRouteCostStructure",
        props: {
            contractor: Object,
            region: Object,
            cost: Object,
            editDialog: Boolean,
            unit_types: Array,
            cost_types: Array,
            shift_types: Array
        },
        data() {
            return {
                valid: true,
                }
        },
        computed: {
            show: {
                get() {
                    return this.editDialog;
                },
                set(value) {
                    if (!value) this.$emit('close');
                }
            },
            isNew() {
                return (this.cost === null || this.cost.id <= 0);
            },
            renderedServices() {
                if (this.services === undefined) return [];
                return this.services;
            },
            renderedZones() {
                if (this.zones === undefined) return [];
                return this.zones;
            },
        },
        asyncComputed: {
            async services() {
                if (this.region === null) return [];
                return await axios.get(process.env.API_URL + '/services')
                    .then((response) => {
                        if (response.status === 200) {
                            response.data.unshift({id: 0, name: "Any"});
                            return response.data;
                        } else {
                            return [{id: 0, name: "Any"}]
                        }
                    })
                    .catch((error) => {
                        return [{id: 0, name: "Any"}]
                    })
            },
            async zones() {
                if (this.region === null) return [];
                return await axios.get(process.env.API_URL + '/regions/' + this.region.id + '/zones')
                    .then((response) => {
                        if (response.status === 200) {
                            let ret = Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
                            ret.unshift({id: 0, name: "Any"});
                            return ret
                        } else {
                            return [{id: 0, name: "Any"}]
                        }
                    })
                    .catch((error) => {
                        return [{id: 0, name: "Any"}]
                    })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Routes/EditRouteCostStructure.vue